module.exports = __webpack_public_path__ + "assets/img/TLSC7-1.b9f4d646.jpg";